const isSafari = (window as any).safari;

export default isSafari